import * as React from "react";
import { Component } from "react";
import styles from "../../styles/wizards/superadmin/AddSpecificationGroupWizard.scss";
import autobind from "autobind-decorator";
import AddSpecificationGroupIcon from "../../assets/images/add-functional-space-64x64.svg";
import { mapStateToProps, setTableParams, validateForm } from "../../core/utils";
import { withRouter } from "react-router";
import { setNotification } from "../../redux/actions/general/notification";
import { createSpecificationGroup, listSpecificationGroups } from "../../redux/actions/table/superadmin/specification_groups";
import AddSpecificationGroupForm from "../../forms/superadmin/add_specification_groups_wizard/AddSpecificationGroupForm";

@withRouter
@mapStateToProps(state => ({
	table: state.table["superadmin_specification_groups"],
}))
class AddSpecificationGroupWizard extends Component {
	@autobind
	_handleSubmit(formData) {
		const { edit } = formData;

		return validateForm(
			createSpecificationGroup(formData).then(({ response }) => {
				listSpecificationGroups().then(() => {
					if (edit) {
						setTableParams('superadmin_specification_groups', {
							clicked_row: response.data.id
						});
					}
				});

				setTableParams('superadmin_specification_groups', {
					actioned_row: undefined,
					selected_rows: []
				});

				this.props.onClose();

				setNotification("You have successfully added a new specification group.");
			})
		);
	}

	render() {
		return (
			<>
				<div className={styles.header}>
					<div className={styles.left}>
						<span>Add specification group</span>
						<span>Add specification group to system specification groups</span>
					</div>
					<div className={styles.right}>
						<AddSpecificationGroupIcon />
					</div>
				</div>
				<div className={styles.body}>
					<AddSpecificationGroupForm onSubmit={this._handleSubmit} initialValues={{
						name: {},
						code: {},
					}} />
				</div>
			</>
		);
	}
}

export default AddSpecificationGroupWizard;